import React from "react";
import { Redirect } from "react-router";
import { Routes } from "../../../constants/routes";
import { useAuth } from "../../auth/hooks/useAuth";
import { UserRole } from "../../user/enums/UserRole";

const HomePage = () => {
  const { user } = useAuth();

  if (user.role === UserRole.School) {
    return <Redirect to={`/0/${Routes.BRANCHES}`} />;
  }

  if (user.role === UserRole.ServiceProvider) {
    return <Redirect to={`/0/${Routes.SERVICES}`} />;
  }

  if (user.role === UserRole.Teacher) {
    return <Redirect to={`/0/${Routes.PRIVATE_CLASSES_MANAGE}`} />;
  }

  return <Redirect to={`/0/${Routes.PROGRAMS}`} />;
};

export default HomePage;
